import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IServiceProviderAvailability, IServiceProviderAvailabilityRequest } from "@ontime/types";

const API_URL = (organizationId: string, serviceProviderId: string) => `${ApiURL()}/organizations/${organizationId}/serviceProvider/${serviceProviderId}/serviceProviderAvailability`;

class ServiceProviderAvailabilityService {

    async GetList(organizationId: string, serviceProviderId: string, showDeleted: boolean = false): Promise<IServiceProviderAvailability[]> {
        const response = await axios.get<IServiceProviderAvailability[]>(API_URL(organizationId, serviceProviderId), {
            headers: AuthHeader(),
            params: { showDeleted }
        });
        return response.data;
    }

    async Get(organizationId: string, serviceProviderId: string, serviceProviderAvailabilityId: string): Promise<IServiceProviderAvailability> {
        const response = await axios.get<IServiceProviderAvailability>(`${API_URL(organizationId, serviceProviderId)}/${serviceProviderAvailabilityId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, serviceProviderId: string, input: IServiceProviderAvailabilityRequest): Promise<IServiceProviderAvailability> {
        const response = await axios.post<IServiceProviderAvailability>(API_URL(organizationId, serviceProviderId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, serviceProviderId: string, input: IServiceProviderAvailabilityRequest): Promise<IServiceProviderAvailability> {
        const response = await axios.put<IServiceProviderAvailability>(API_URL(organizationId, serviceProviderId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, serviceProviderId: string, serviceProviderAvailabilityId: string, currentIsDeleted: boolean): Promise<{ serviceProviderAvailabilityId: string }> {
        const response = await axios.delete<{ serviceProviderAvailabilityId: string }>(`${API_URL(organizationId, serviceProviderId)}/${serviceProviderAvailabilityId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new ServiceProviderAvailabilityService();